import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CheckCircleRegular from './check-circle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CheckCircleRegular {...validProps} />;
}

SvgComponent.iconName = 'checkCircleRegular';

export const CheckCircleRegularIcon = svgIconWrapper(SvgComponent);
